/**
 * The picker param that says "start hosted Checkout for this target, now".
 *
 * Set only by the checkout page, and only when the Elements rollout toggle went off while a buyer
 * had the screen open. As a modal that fallback needed no URL — the picker was already mounted and
 * could just be told. A page cannot tell anything; it can only navigate, so the instruction has to
 * survive the navigation.
 *
 * Its own module rather than a constant in either page: both import it, and a checkout page that
 * imported the picker (or the reverse) would drag one route's component tree into the other's bundle.
 */
export const HOSTED_FALLBACK_PARAM = 'hostedFallback';
